import React from 'react';
import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { fsClass } from '@/styles/typography';

interface AuthFooterProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Cosmos trust strip for authentication pages (Login, Activate, Reset Password):
 * subtle ice top border, lock icon, uppercase tracked secure-connection caption.
 */
const AuthFooter: React.FC<AuthFooterProps> = ({ className = '', children }) => {
  const { t } = useTranslation();
  if (children) {
    return <footer className={`w-full ${className}`}>{children}</footer>;
  }

  return (
    <footer
      className={`flex flex-col items-center justify-center h-full min-h-0 relative w-full py-2 px-3 border-t border-border-ice bg-space-top/80 backdrop-blur-md ${className}`}
    >
      <div className="inline-flex items-center gap-2 py-1.5 px-3 sm:px-4 rounded-full bg-white/5 border border-border-ice backdrop-blur-sm">
        <span className="flex-shrink-0 rounded-full bg-success w-1.5 h-1.5" aria-hidden />
        <Lock className="w-3 h-3 flex-shrink-0 text-ice/70" aria-hidden />
        <span className={`font-ui ${fsClass.base} font-semibold uppercase tracking-[0.2em] text-ice/80 whitespace-nowrap`}>
          {t('authFooter.secureConnectionEstablished')}
        </span>
      </div>
    </footer>
  );
};

export default AuthFooter;
